/* VALURAA OFFERS — bundle-and-save + free shipping progress for the cart drawer, cart page and product page.
   The numbers below must match the automatic discounts in Shopify admin (Discounts):
   "Buy 2 · 10% off", "Buy 3 · 15% off", "Buy 4+ · 20% off", "Free shipping over Rs. 999".
   Shopify applies the discount itself; this file only shows progress. Delete this file and its line in layout/theme.liquid to remove. */
(() => {
  const TIERS = [
    { qty: 2, pct: 10 },
    { qty: 3, pct: 15 },
    { qty: 4, pct: 20 }
  ];
  const FREE_SHIPPING_CENTS = 99900;
  const STORE_KEY = 'vfo:last';
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  const money = (cents) => 'Rs. ' + (Math.max(0, cents) / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const read = () => { try { return JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null'); } catch (e) { return null; } };
  const write = (v) => { try { sessionStorage.setItem(STORE_KEY, JSON.stringify(v)); } catch (e) {} };

  const tierFor = (qty) => { let t = null; TIERS.forEach((x) => { if (qty >= x.qty) t = x; }); return t; };
  const nextTier = (qty) => TIERS.find((x) => qty < x.qty) || null;
  /* equal segments: 1 → 2 → 3 → 4+  mapped to 0% → 33% → 67% → 100% */
  const fillFor = (qty) => {
    if (qty <= 0) return 0;
    if (qty === 1) return 8;
    return Math.min(100, ((Math.min(qty, 4) - 1) / 3) * 100);
  };
  const shipFor = (total) => Math.min(100, (total / FREE_SHIPPING_CENTS) * 100);

  const truck = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6.5h11v9H3zM14 9.5h3.6l2.9 3v3H14z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="7" cy="17" r="1.7" fill="none" stroke="currentColor" stroke-width="1.5"/><circle cx="17.2" cy="17" r="1.7" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
  const check = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const spark = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l1.8 5.4L19 10l-5.2 1.6L12 17l-1.8-5.4L5 10l5.2-1.6z" fill="currentColor"/></svg>';

  const message = (qty) => {
    const now = tierFor(qty);
    const next = nextTier(qty);
    if (!now && next) {
      const need = next.qty - qty;
      return { head: 'Add ' + need + ' more ' + (need === 1 ? 'piece' : 'pieces') + ' to save ' + next.pct + '%', sub: 'Bundle pricing is applied automatically at checkout.' };
    }
    if (now && next) {
      return { head: now.pct + '% off applied', sub: 'Add 1 more piece to save ' + next.pct + '%.' };
    }
    return { head: 'Best price unlocked — ' + now.pct + '% off', sub: 'Maximum bundle saving applied to every piece.' };
  };

  const build = (cart, variant) => {
    const qty = cart.item_count || 0;
    const total = cart.total_price || 0;
    const saved = cart.total_discount || 0;
    const msg = message(qty);
    const now = tierFor(qty);
    const shipDone = total >= FREE_SHIPPING_CENTS;
    const el = document.createElement('section');
    el.className = 'vfo vfo--' + variant + (now ? ' has-tier' : '') + (qty >= 4 ? ' is-max' : '');
    el.setAttribute('data-vfo', '');
    el.setAttribute('aria-label', 'Bundle offer and free shipping');
    el.innerHTML =
      '<div class="vfo__top">' +
        '<span class="vfo__badge">' + spark + '<span>Bundle &amp; save</span></span>' +
        (saved > 0 ? '<span class="vfo__saved">You save <strong>' + money(saved) + '</strong></span>' : '') +
      '</div>' +
      '<p class="vfo__head" aria-live="polite">' + msg.head + '</p>' +
      '<p class="vfo__sub">' + msg.sub + '</p>' +
      '<div class="vfo__rail" role="progressbar" aria-label="Bundle progress" aria-valuemin="0" aria-valuemax="4" aria-valuenow="' + Math.min(qty, 4) + '">' +
        '<span class="vfo__track"><span class="vfo__fill" data-vfo-fill></span></span>' +
        TIERS.map((t, i) => {
          const done = qty >= t.qty;
          const pos = ((i + 1) / 3) * 100;
          return '<span class="vfo__step' + (done ? ' is-done' : '') + (i === TIERS.length - 1 ? ' is-last' : '') + '" style="--pos:' + pos + '%" data-vfo-step="' + t.qty + '">' +
            '<i>' + (done ? check : '') + '</i>' +
            '<b>' + t.qty + (i === TIERS.length - 1 ? '+' : '') + ' pcs</b><em>' + t.pct + '% off</em></span>';
        }).join('') +
      '</div>' +
      '<div class="vfo__ship' + (shipDone ? ' is-done' : '') + '">' +
        '<span class="vfo__ship-icon">' + (shipDone ? check : truck) + '</span>' +
        '<span class="vfo__ship-copy">' + (shipDone ? '<strong>Free shipping unlocked</strong>' : 'Add <strong>' + money(FREE_SHIPPING_CENTS - total) + '</strong> for free shipping') + '</span>' +
        '<span class="vfo__ship-track"><span data-vfo-ship></span></span>' +
      '</div>';
    return { el, qty, fill: fillFor(qty), ship: shipFor(total) };
  };

  const animate = (built) => {
    const last = read();
    const fill = built.el.querySelector('[data-vfo-fill]');
    const ship = built.el.querySelector('[data-vfo-ship]');
    const fromFill = last && typeof last.fill === 'number' ? last.fill : 0;
    const fromShip = last && typeof last.ship === 'number' ? last.ship : 0;
    if (reduce) {
      fill.style.width = built.fill + '%';
      ship.style.width = built.ship + '%';
    } else {
      fill.style.width = fromFill + '%';
      ship.style.width = fromShip + '%';
      requestAnimationFrame(() => requestAnimationFrame(() => {
        fill.style.width = built.fill + '%';
        ship.style.width = built.ship + '%';
      }));
      const lastQty = last && typeof last.qty === 'number' ? last.qty : 0;
      if (built.qty > lastQty) {
        built.el.querySelectorAll('.vfo__step.is-done').forEach((s) => {
          if (Number(s.dataset.vfoStep) > lastQty) s.classList.add('is-new');
        });
        if (tierFor(built.qty) !== tierFor(lastQty)) built.el.classList.add('is-celebrate');
      }
    }
    write({ qty: built.qty, fill: built.fill, ship: built.ship });
  };

  let cartPromise = null;
  const getCart = () => {
    if (!cartPromise) {
      cartPromise = fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then((r) => r.json())
        .finally(() => setTimeout(() => { cartPromise = null; }, 150));
    }
    return cartPromise;
  };

  const mountDrawer = async (body) => {
    if (body.dataset.vfoMounted === '1') return;
    body.dataset.vfoMounted = '1';
    const cart = await getCart();
    if (!body.isConnected || !cart || !cart.item_count) return;
    body.querySelectorAll(':scope > [data-vfo]').forEach((n) => n.remove());
    const built = build(cart, 'drawer');
    body.prepend(built.el);
    animate(built);
  };

  const mountCartPage = async () => {
    const form = document.getElementById('VfCartForm');
    if (!form || form.dataset.vfoMounted === '1') return;
    form.dataset.vfoMounted = '1';
    const cart = await getCart();
    if (!cart || !cart.item_count) return;
    const built = build(cart, 'page');
    form.parentNode.insertBefore(built.el, form);
    animate(built);
  };

  const mountProductHint = () => {
    if (!document.body.classList.contains('template-product')) return;
    if (document.querySelector('[data-vfo-hint]')) return;
    const form = document.querySelector('main form[action*="/cart/add"]');
    if (!form) return;
    const hint = document.createElement('div');
    hint.className = 'vfo-hint';
    hint.setAttribute('data-vfo-hint', '');
    hint.innerHTML =
      '<p class="vfo-hint__title">' + spark + '<span>Bundle &amp; save — applied automatically</span></p>' +
      '<ul role="list">' + TIERS.map((t, i) => '<li><b>' + t.qty + (i === TIERS.length - 1 ? '+' : '') + ' pcs</b><span>' + t.pct + '% off</span></li>').join('') + '</ul>' +
      '<p class="vfo-hint__ship">' + truck + '<span>Free shipping on orders over Rs. 999</span></p>';
    form.insertAdjacentElement('afterend', hint);
  };

  const scan = () => {
    document.querySelectorAll('[data-vf-drawer] [data-vf-drawer-body]').forEach((b) => { if (b.dataset.vfoMounted !== '1') mountDrawer(b); });
    mountCartPage();
    mountProductHint();
  };

  let queued = false;
  const queueScan = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; scan(); });
  };

  const start = () => {
    scan();
    new MutationObserver((list) => {
      for (const m of list) {
        for (const n of m.addedNodes) {
          if (n.nodeType === 1 && (n.matches?.('[data-vf-drawer]') || n.querySelector?.('[data-vf-drawer]'))) { queueScan(); return; }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
